import React, { useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Avatar,
  Typography,
  IconButton,
  Box,
  Paper,
  Container,
} from "@mui/material";

import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import { EditIcon } from "../comps/CustomIcons";

export default function MasterAdminProfileEdit() {
  const [user, setUser] = useState({
    name: "Rahul Shrama",
    email: "rahul@hdujl.com.in.xy",
    contact: "852649571",
  });
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box
          sx={{
            width: "100%",
            pr: "90px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              my: "20px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit" }}>Profile</Typography>
          </Box>
          <Box
            component="form"
            sx={{
              backgroundColor: "rgba(240, 247, 252, 1)",
              display: "flex",
              justifyContent: "space-evenly",
              p: "15px",
              borderRadius: "8px",
            }}
          >
            {/* left side  */}
            <Box
              sx={{
                mx: "25px",

                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              <Typography>Edit Profile</Typography>
              <Box
                sx={{
                  width: "150px",
                  height: "225px",
                  border: "1px solid black",
                  borderRadius: 2,

                  backgroundColor: "white",
                  display: "flex", // Enables flexbox
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(223, 232, 239, 1)",
                    height: "30px",
                    width: "67px",
                    m: "10px",
                    pl: "10px",
                    borderRadius: "5px",
                    alignSelf: "flex-end",
                    marginTop: "auto",
                  }}
                >
                  <Typography>Edit</Typography>
                  <IconButton>
                    <EditIcon
                      sx={{
                        cursor: "pointer",
                        color: "transparent",
                        fontSize: "18px",
                      }}
                    />
                  </IconButton>
                </Box>
              </Box>
              <Button
                variant="outlined"
                sx={{ textTransform: "none", width: "150px" }}
              >
                Upload
              </Button>
            </Box>

            {/* right side  */}
            <Box
              sx={{
                width: "100%",
                p: "25px",
                my: "10px",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  required
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  required
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Contact Number"
                  name="contactNumber"
                  required
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: "20px",
                }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    textTransform: "none",
                    backgroundColor: "rgba(1, 121, 176, 1)",
                    width: "150px",
                  }}
                >
                  Save Changes
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
